import { Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../utils/DateUtils';
import { getReferenceTypeName, getUnitById } from '../../../utils/Enums';

const ViewStockMovementModal = ({ open, onClose, movement }) => {
  const { t } = useTranslation();

  if (!movement) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('stock_movement_details')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight="bold">{t('date')}:</Typography>
            <Typography>{formatDate(movement.date)}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight="bold">{t('responsible')}:</Typography>
            <Typography>{movement.staff.firstName} {movement.staff.lastName}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight="bold">{t('source_branch')}:</Typography>
            <Typography>{movement.sourceBranch?.name}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight="bold">{t('destination_branch')}:</Typography>
            <Typography>{movement.destinationBranch?.name}</Typography>
          </Grid>
        </Grid>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('reference_type')}</TableCell>
              <TableCell align='center'>{t('reference')}</TableCell>
              <TableCell align='center'>{t('quantity')}</TableCell>
              <TableCell align='center'>{t('unit')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movement.items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{getReferenceTypeName(item.referenceType)}</TableCell>
                <TableCell align='center'>{item.referenceName}</TableCell>
                <TableCell align='center'>{parseFloat(item.quantity).toFixed(1)}</TableCell>
                <TableCell align='center'>{getUnitById(item.unit).label}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default ViewStockMovementModal;
